import {
  FC, PropsWithChildren, createContext,
} from 'react';

export interface XRouterContextType {
  basename: string;
  location?: string;
}

export const XRouterContext = createContext<XRouterContextType>({
  basename: '/',
});

export const XRouter: FC<PropsWithChildren<XRouterContextType>> = ({
  children,
  location,
  basename = '/',
}) => (
  <XRouterContext.Provider value={{ basename, location }}>
    {children}
  </XRouterContext.Provider>
);
